/**
 * Her email subject lines.
 *
 * "can we get a drop down list for subject in emails: Lab Work / Lab Script /
 * Recommendation Letter / Default Heavenly Hydration."
 *
 * A datalist rather than a <select>, because she still needs to type a one-off
 * subject and a hard dropdown would take that away. The list lives in workspace
 * settings, not in this file, so she can change it in Settings without waiting
 * on a deploy — her four are only the starting point.
 */
import { useEffect, useState } from "react";
import { api } from "./api";
import type { WorkspaceSettings } from "./types";

export const DEFAULT_EMAIL_SUBJECTS = [
  "Heavenly Hydration",
  "Lab Work",
  "Lab Script",
  "Recommendation Letter",
];

/** One fetch, shared — the composer mounts on every conversation. */
let cached: string[] | null = null;
const waiting: ((s: string[]) => void)[] = [];
let inFlight = false;

export function parseSubjects(raw: unknown): string[] {
  if (typeof raw !== "string" || raw.trim() === "") return DEFAULT_EMAIL_SUBJECTS;
  const list = raw.split("\n").map((s) => s.trim()).filter(Boolean);
  return list.length > 0 ? list : DEFAULT_EMAIL_SUBJECTS;
}

export function useEmailSubjects(): string[] {
  const [subjects, setSubjects] = useState<string[]>(cached ?? DEFAULT_EMAIL_SUBJECTS);
  useEffect(() => {
    if (cached) { setSubjects(cached); return; }
    waiting.push(setSubjects);
    if (inFlight) return;
    inFlight = true;
    api.get<{ settings: WorkspaceSettings }>("/settings")
      .then((d) => {
        const ms = ((d.settings.settings as Record<string, unknown>)?.medspa ?? {}) as Record<string, unknown>;
        cached = parseSubjects(ms.email_subjects);
      })
      .catch(() => { cached = DEFAULT_EMAIL_SUBJECTS; })
      .finally(() => {
        inFlight = false;
        while (waiting.length) waiting.pop()!(cached ?? DEFAULT_EMAIL_SUBJECTS);
      });
  }, []);
  return subjects;
}
